import React from 'react';
import Box from '../Box/Box';
import InlineFeedbackIcon from './InlineFeedbackIcon';

import TEFeedbackSignal from '../../types/TEFeedbackSignal';

type TInlineFeedbackBase = {
  icon?: string;
  signal: TEFeedbackSignal;
  children: React.ReactNode;
};

const InlineFeedbackBase = ({ children, icon, signal, ...rest }: TInlineFeedbackBase) => (
  <Box as="div" {...rest} name="InlineFeedback" modifiers={signal}>
    {icon && <InlineFeedbackIcon icon={icon} signal={signal} />}
    {children}
  </Box>
);

export default InlineFeedbackBase;
